export default __webpack_public_path__ + "static/media/template18.6cb28e87.svg";